import { render } from "./OlabChemical.vue?vue&type=template&id=5cbec170&scoped=true"
import script from "./OlabChemical.vue?vue&type=script&lang=js"
export * from "./OlabChemical.vue?vue&type=script&lang=js"

import "./OlabChemical.vue?vue&type=style&index=0&id=5cbec170&scoped=true&lang=css"

import exportComponent from "/Users/ckyang/dev/olabbio/sites/olab-github/gf-olab-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbec170"]])

export default __exports__